"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaqCategory = void 0;
var FaqCategory;
(function (FaqCategory) {
    FaqCategory["STUDY"] = "STUDY";
    FaqCategory["EDC"] = "EDC";
})(FaqCategory = exports.FaqCategory || (exports.FaqCategory = {}));
//# sourceMappingURL=faq.js.map